module.exports = __webpack_public_path__ + "img/solid_box_big@2x.c5c126ea.png";